/* ecoPhone – popis stavu pod výberom variantu + video pop-up (Oriešeks, 10/2026) */
if (!window.customElements.get('condition-info')) {
  class ConditionInfo extends HTMLElement {
    connectedCallback() {
      this.position = this.getAttribute('option-position');
      this._current = this.querySelector('.condition-info__item:not([hidden])')?.dataset.condition;
      this.form = document.forms[this.getAttribute('form')];
      this._onVariantChange = (event) => this._update(event.detail?.variant?.['option' + this.position], true);
      this._onInputChange = (event) => {
        const input = event.target;
        if (input.name === 'option' + this.position && input.checked) this._update(input.value, true);
      };
      this.form?.addEventListener('variant:change', this._onVariantChange);
      document.addEventListener('change', this._onInputChange);

      this.querySelectorAll('.condition-info__video-btn').forEach((button) => {
        button.addEventListener('click', () => this._openVideo(document.getElementById(button.getAttribute('aria-controls'))));
      });
      this.querySelectorAll('.condition-info__dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog || event.target.closest('[data-close]')) dialog.close();
        });
        dialog.addEventListener('close', () => {
          const video = dialog.querySelector('video');
          if (video) { video.pause(); video.currentTime = 0; }
          document.documentElement.classList.remove('condition-info-lock');
        });
      });

      this._syncHeader = () => {
        const summary = this.querySelector('.condition-info__item:not([hidden]) summary');
        if (summary) this.style.setProperty('--condition-info-header', summary.offsetHeight + 'px');
      };
      this._syncHeader();
      window.addEventListener('resize', this._syncHeader);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._syncHeader);
      this.form?.removeEventListener('variant:change', this._onVariantChange);
      document.removeEventListener('change', this._onInputChange);
    }

    /* Po kliknutí na stav sa zodpovedajúci popis automaticky rozbalí */
    _update(value, open = false) {
      if (value == null) return;
      if (value === this._current) return; /* zmena inej možnosti (napr. farby) popis nemení */
      this._current = value;
      const items = Array.from(this.querySelectorAll('.condition-info__item'));
      const wasOpen = items.some((item) => !item.hidden && item.querySelector('details')?.open);
      items.forEach((item) => {
        const match = item.dataset.condition === value;
        item.hidden = !match;
        const details = item.querySelector('details');
        if (details) {
          details.open = match && (open || wasOpen);
          details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        }
      });
      this._syncHeader();
    }

    _openVideo(dialog) {
      if (!dialog) return;
      dialog.showModal();
      document.documentElement.classList.add('condition-info-lock');
      const video = dialog.querySelector('video');
      video?.play().catch(() => {});
    }
  }
  window.customElements.define('condition-info', ConditionInfo);
}
